import { pxToRem } from '../../../../lib';
var formFieldStyles = {
  root: function root(_ref) {
    var props = _ref.props,
        variables = _ref.variables;
    return {};
  },
  label: function label(_ref2) {
    var props = _ref2.props;
    var type = props.type,
        inline = props.inline,
        required = props.required;
    return Object.assign({}, (!type || type !== 'radio' && type !== 'checkbox') && {
      display: 'block'
    }, inline && {
      marginRight: pxToRem(10),
      display: 'inline'
    }, required && {
      '::after': {
        content: '"*"'
      }
    });
  },
  control: function control(_ref3) {
    var props = _ref3.props;
    var type = props.type;
    return Object.assign({}, type && (type === 'radio' || type === 'checkbox') && {
      marginRight: pxToRem(10)
    });
  },
  message: function message() {
    return {
      display: 'block'
    };
  }
};
export default formFieldStyles;